import React from 'react'

import EnterAccountPasswordWrapper from '../../../modules/enter-account-password-modal/enter-account-password-wrapper'
import OfferContent from './offer-content'

function Offer() {
  return (
    <EnterAccountPasswordWrapper>
      <OfferContent />
    </EnterAccountPasswordWrapper>
  )
}

export default Offer
